
import Vue from "vue";
import Component from "vue-class-component";
import AppNavbar from "@/components/layout/AppNavbar.vue";
import AppHeader from "@/components/layout/AppHeader.vue";
import NewsFromAdmin from "@/components/landing/NewsFromAdmin.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import Features from "@/components/landing/Features.vue";
import { Action, State } from "vuex-class";
import { AxiosResponse } from "axios";
import { SchoolTemplateSectionTypeEnum } from "@/constants/enum.constant";
import SingleImage from "@/components/content-management/single-image/SingleImage.vue";
import ImageSlider from "@/components/content-management/image-slider/ImageSlider.vue";
import News from "@/components/content-management/news/News.vue";
import Events from "@/components/content-management/events/Events.vue";
import Jobs from "@/components/content-management/jobs/Jobs.vue";
import Maintenance from "@/views/Maintenance.vue";

@Component({
  components: {
    Maintenance,
    Jobs,
    ImageSlider,
    SingleImage,
    Events,
    Features,
    AppNavbar,
    AppHeader,
    News,
    NewsFromAdmin,
    AppFooter,
  },
})
export default class Landing extends Vue {
  @Action("getPageDefault", { namespace: "school" })
  private getPageDefault: any;

  @State("school", { namespace: "school" })
  private school!: any;

  private page: any = null;

  private created() {
    this.getPageDefault({
      success: (response: AxiosResponse) => {
        this.page = response.data.data;
      },
    });
  }

  private get templateNumber() {
    return Number(this.$route.query.template) || 1;
  }

  private get isMaintenance() {
    return false;
  }

  private isOneColumnContent(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.ONE_COLUMN_CONTENT;
  }
  private isTwoColumnContent(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.TWO_COLUMN_CONTENT;
  }
  private isSingleImage(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.SINGLE_IMAGE;
  }
  private isImageSlider(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.IMAGE_SLIDER;
  }
  private isNews(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.NEWS;
  }
  private isEvents(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.EVENTS;
  }
  private isJobPostings(section: any) {
    return section.type === SchoolTemplateSectionTypeEnum.JOB_POSTINGS;
  }
}
